// Trigger a browser "save file" for an in-memory Blob — e.g. a PDF fetched with the
// bearer attached (see ApiClient.getBlob). The object-URL lifecycle is self-contained:
// created, clicked through a transient anchor, then revoked so nothing leaks. Browser-only
// (the apps here have no SSR); kept tiny and dependency-free so both realms reuse it.
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
